import { Box } from '@mui/material';
import { useRef } from 'react';
import TAGButton from '@shared-components/components/TAGButton/TAGButton';
import { convertTimeTo12HourFormat, useNextAppointment } from '@shared-components/hooks/useNextAppointment/useNextAppointment';
import useResetFocusOnBfcacheRestore from '@shared-components/hooks/useResetFocusOnBfcacheRestore/useResetFocusOnBfcacheRestore';
export default function ServiceLineHeroPAO() {
  const {
    officeInfo,
    siteUrl,
    appointment,
    scheduleText
  } = useNextAppointment('sick');
  const buttonsRef = useRef<HTMLDivElement>(null);
  useResetFocusOnBfcacheRestore(buttonsRef);
  if (!officeInfo) {
    return null;
  }
  const allTimesUrl = `${siteUrl}/book-an-appointment/?fc=${officeInfo.code}&visitReason=sick`;
  return <Box ref={buttonsRef} sx={{
    display: 'flex',
    gap: 1,
    flexWrap: 'wrap'
  }} data-sentry-element="Box" data-sentry-component="ServiceLineHeroPAO" data-sentry-source-file="ServiceLineHeroPAO.tsx">
			{appointment ? <>
					<TAGButton size="M" variant="primaryDefault" data-testid="service_line_hero_pao_schedule_button" href={`${allTimesUrl}&timeSlot=${appointment.date}T${appointment.time}`}>
						Schedule {scheduleText} at {convertTimeTo12HourFormat(appointment.time)}
					</TAGButton>
					<TAGButton size="M" variant="secondaryDefault" data-testid="service_line_hero_pao_all_times_button" href={allTimesUrl} sx={{
        backgroundColor: 'common.white',
        '&:hover': {
          backgroundColor: 'common.white'
        }
      }}>
						See all available times
					</TAGButton>
				</> : <TAGButton size="M" variant="primaryDefault" data-testid="service_line_hero_pao_schedule_button" href={allTimesUrl}>
					Schedule Now
				</TAGButton>}
		</Box>;
}